import { Button, Col, Form, DatePicker, Row } from "antd";
import moment from "moment";
import { stepperMoving, AccountEntriesData,setAccountEntriesDateRange } from '../../stores/actions';
import { useDispatch } from 'react-redux';
import helper from '../../utils/helper';
import { message } from 'antd';
import { errorMessage } from '../../utils/commonStringsConsts';
export default function GenerateAccountEntries() {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const startDate = Form.useWatch("startDate", form);

    const disabledEndDate = (current: any) => {
        const today = moment().endOf("day");
        if (!startDate) return current && current > today;
        return current && (current < startDate || current > today);
    };
    const getAccountsEntries = async () => {
        try {
            const res: any = await helper.getAccountsEntries();
            if (res?.status !== 200) {
                message.error(`${errorMessage}`);
                return
            }
            const data = res?.data?.data?.servicesGroups;
            dispatch(AccountEntriesData(data));

        } catch (error) {
            message.error(`${errorMessage} with Accounts Entries data`);
        }
    }
    const generate = async (values: any) => {
        dispatch(setAccountEntriesDateRange(values?.startDate, values?.endDate));
        await getAccountsEntries(); 
        dispatch(stepperMoving(1));
    };

    return (
        <div className="createEarlyPayment">
            <Form
                form={form}
                name="nest-messages"
                onFinish={generate}
            >
                <Row className="inputsRow">
                    <Col span={12}>
                        <label>Start Date <span>*</span></label>
                        <Form.Item
                            className='collectionDate'
                            name="startDate"
                            rules={[{ required: true, message: 'Required' }]}
                        >
                            <DatePicker />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <label>End Date <span>*</span></label>
                        <Form.Item
                            className='collectionDate'
                            name="endDate"
                            rules={[
                                { required: true, message: 'Required' },
                            ]}
                        >
                            <DatePicker disabledDate={disabledEndDate} />
                        </Form.Item>
                    </Col>
                    <Col span={24} className="btnCol">
                        <Form.Item>
                            <Button shape="round" type="primary" htmlType="submit">
                                Generate
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </div>
    );
}
